/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_LogoutInputs */

const he_auth_logout = /** @type {(inputs: Auth_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התנתק`)
};

const en_auth_logout = /** @type {(inputs: Auth_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

/**
* | output |
* | --- |
* | "Log out" |
*
* @param {Auth_LogoutInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_logout = /** @type {((inputs?: Auth_LogoutInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_LogoutInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_logout(inputs)
	return en_auth_logout(inputs)
});